import React, { useEffect, useState, useMemo, useContext } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { toastWarn } from "../../../common/Toast";
import { Box } from "@mui/material";
import { checkUserPermission } from "../../../common/UserPermission";
import { Cell } from "jspdf-autotable";
import { Noimage } from "../../../common/imagePath";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const PurchasesByCategoriesSummary = (props) => {
  let PERMISSION_SHOW_COST_PRICE = "show-cost-price";
  let PERMISSION_SHOW_PROFIT_PRICE = "show-profit-price";
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);

  const [responseData, setResponseData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [categories, setCategories] = useState([]);
  const [categoriesId, setCategoriesId] = useState([]);
  const [customerid, setcustomerid] = useState(0);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [agingPeriod, setAgingPeriod] = useState(30);
  const [numberPeriod, setNumberPeriod] = useState(4);
  const [brands, setBrands] = useState([]);
  const [brandId, setBrandId] = useState([]);
  const [mindayspastdue, setMindayspastdue] = useState(0);

  const [selectedItems, setSelectedItems] = useState([]);
  const [checkbox, setCheckBox] = useState({
    showNonZero: false,
    showDeletedItems: false,
    showParentItem: false,
  });

  const [showMoreFilters, setShowMoreFilters] = useState(false);
  const [searchItemName, setSearchItemName] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [classicView, setClassicView] = useState(true);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handelItemSearch = (value) => {
    if (value != "") {
      setSuggestions([]);
      axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/searchforaccount?searchparam=${encodeURIComponent(
            value
          )}&iscategory=${0}&customerid=${0}&supplierid=${0}&locationid=${locationid}&itemsearchtype=sale&isservice=${1}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log(res.data.ResponseData, "resdata2709");
          if (res.data.ResponseData.length > 0) {
            const modifiedData = res.data.ResponseData.map((item) => ({
              ...item,
              ID: item.ItemId,
              VariationId: item.VariationId,
              Name:
                item.VariationName != "" ? item.VariationName : item.ItemName,
              ImageURL: item.ImageName,
              Quantity:
                item.VariationId != 0
                  ? item.VariationQuantity
                  : item.Itemquantity,
              Categoryfullpath: item.CategoryName,
            }));
            setSuggestions(modifiedData);
            setLoading(false);
          } else {
            toastWarn("No Item Found");
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setSuggestions([]);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      handelItemSearch(searchItemName);
    }, 1000);

    // Cleanup function to clear the timeout if the component unmounts
    // or if searchItemName changes before the delay completes
    return () => {
      clearTimeout(handler);
    };
  }, [searchItemName]);

  // function buildFullCategoryTree(data) {
  //   const idToNodeMap = {};
  //   const root = [];

  //   const getNodeIdByPath = (pathIds) => pathIds.join(",");

  //   data.forEach((item) => {
  //     const pathIds = item.CategoryPathId.split(",");
  //     const pathNames = item.GroupName.split(" > ");

  //     pathIds.forEach((id, index) => {
  //       const currentPath = pathIds.slice(0, index + 1);
  //       const currentPathId = currentPath.join(",");

  //       if (!idToNodeMap[currentPathId]) {
  //         const node = {
  //           CategoryName: pathNames[index],
  //           CategoryPathId: currentPathId,
  //           CategoryParentId: index === 0 ? 0 : parseInt(pathIds[index - 1]),
  //           GroupName: pathNames.slice(0, index + 1).join(" > "),
  //         };
  //         idToNodeMap[currentPathId] = node;
  //       }

  //       // If it's the last level, merge actual data
  //       if (index === pathIds.length - 1) {
  //         Object.assign(idToNodeMap[currentPathId], item);
  //       }
  //     });
  //   });

  //   // Now build the tree
  //   Object.values(idToNodeMap).forEach((node) => {
  //     const pathParts = node.CategoryPathId.split(",");
  //     if (node.CategoryParentId === 0 || pathParts.length === 1) {
  //       root.push(node);
  //     } else {
  //       const parentPath = pathParts.slice(0, -1).join(",");
  //       const parent = idToNodeMap[parentPath];
  //       if (parent) {
  //         if (!parent._children) parent._children = [];
  //         parent._children.push(node);
  //       }
  //     }
  //   });

  //   return root;
  // }

  function buildFullCategoryTree(data) {
    const idToNodeMap = {};
    const root = [];

    // Define keys to default to 0 for dummy (missing) nodes
    const defaultZeroFields = [
      "QuantityReceived",
      "SubTotal",
      "Total",
      "Discount",
      "Profit",
      "CurrentStockQty",
      "StockValue",
      "StockPercentage",
      "ProfitPercent",
      "QtySold",
      "SalePercentage",
    ];

    data.forEach((item) => {
      const pathIds = item.CategoryPathId.split(",");
      const pathNames = item.GroupName.split(" > ");

      pathIds.forEach((id, index) => {
        const currentPath = pathIds.slice(0, index + 1);
        const currentPathId = currentPath.join(",");

        if (!idToNodeMap[currentPathId]) {
          const isLast = index === pathIds.length - 1;

          const node = {
            CategoryName: pathNames[index],
            CategoryPathId: currentPathId,
            CategoryParentId: index === 0 ? 0 : parseInt(pathIds[index - 1]),
            GroupName: pathNames.slice(0, index + 1).join(" > "),
          };

          // If this is a missing middle node (not in original data), set zero fields
          if (!isLast) {
            defaultZeroFields.forEach((key) => {
              node[key] = 0;
            });
          }

          idToNodeMap[currentPathId] = node;
        }

        // For the final node in path, merge original data
        if (index === pathIds.length - 1) {
          Object.assign(idToNodeMap[currentPathId], item);
        }
      });
    });

    // Build the nested tree structure
    Object.values(idToNodeMap).forEach((node) => {
      const pathParts = node.CategoryPathId.split(",");
      if (node.CategoryParentId === 0 || pathParts.length === 1) {
        root.push(node);
      } else {
        const parentPath = pathParts.slice(0, -1).join(",");
        const parent = idToNodeMap[parentPath];
        if (parent) {
          if (!parent._children) parent._children = [];
          parent._children.push(node);
        }
      }
    });

    return root;
  }

  const apiCall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/purchasesbyinventorysubmodulesummaryreport?brandid=${brandId}&categoryid=${categoriesId}&tagid=0&manufacturerid=0&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}&groupbytype=Category&shownonzero=${
          checkbox.showNonZero == true ? 1 : 0
        }&showdeleteditems=${
          checkbox.showDeletedItems == true ? 1 : 0
        }&showparentItem=${
          checkbox.showParentItem == true ? 1 : 0
        }&selectedItems=${encodeURIComponent(JSON.stringify(selectedItems))}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          console.log(res.data.ResponseData, "checkdata");
          const FilterData = res.data.ResponseData?.map((el) => ({
            ...el,
            QuantityReceived: Number(el?.QuantityReceived),
            SubTotal: Number(el?.SubTotal),
            Total: Number(el?.Total),
            Discount: Number(el?.Discount),
            Profit: Number(el?.Profit),
            CurrentStockQty: Number(el?.CurrentStockQty),
            StockValue: Number(el?.StockValue),
            StockPercentage: Number(el?.StockPercentage),
          }));

          const treeData = buildFullCategoryTree(FilterData);
          console.log(treeData, "treedata");
          setResponseData(treeData.sort((a, b) => a.GroupName - b.GroupName));

          if (res.data.ResponseData?.length > 0) {
            setLoading(false);
          } else {
            toastWarn("No data found for the selected date range.");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    // Brand Dropdown
    axios
      .get(`${config.categoriesBaseUrl}/categories/categoriesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const datalist = res.data.ResponseData.map((u) => {
          return { label: u.Name, value: u.ID };
        });
        setCategories(datalist);
      })
      .catch((err) => {
        console.log(err);
      });

    // Brand Dropdown
    axios
      .get(`${config.brandBaseUrl}/brands/brandsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const datalist = res.data.ResponseData.map((u) => {
          return { label: u.Name, value: u.ID };
        });
        setBrands(datalist);
      })
      .catch((err) => {
        console.log(err);
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const headerMenu = function () {
    const table = this;
    const menu = [];
    const columns = table.getColumns();

    // Check if we have saved visibility state in localStorage
    const savedVisibility = localStorage.getItem("columnVisibility");
    const visibilityState = savedVisibility ? JSON.parse(savedVisibility) : {};

    for (let column of columns) {
      const field = column.getField();
      const columnDef = column.getDefinition();
      const defaultVisible = columnDef.defaultVisible == true; // Default to true if not specified

      console.log(visibilityState, "visibilityState", defaultVisible);

      // Determine initial visibility:
      // 1. Use saved state if available
      // 2. Fall back to defaultVisible if no saved state
      const shouldBeVisible = visibilityState.hasOwnProperty(field)
        ? visibilityState[field]
        : defaultVisible;

      // Set column visibility
      if (shouldBeVisible) {
        column.show();
      } else {
        column.hide();
      }

      // Create menu item with icon
      const icon = document.createElement("i");
      icon.classList.add("fas");
      icon.classList.add(column.isVisible() ? "fa-check-square" : "fa-square");

      const label = document.createElement("span");
      const title = document.createElement("span");
      title.textContent = " " + columnDef.title;
      label.appendChild(icon);
      label.appendChild(title);

      menu.push({
        label: label,
        action: function (e) {
          e.stopPropagation();

          // Toggle visibility
          const newVisibility = !column.isVisible();
          if (newVisibility) {
            column.show();
            icon.classList.remove("fa-square");
            icon.classList.add("fa-check-square");
          } else {
            column.hide();
            icon.classList.remove("fa-check-square");
            icon.classList.add("fa-square");
          }

          // Update and save visibility state
          visibilityState[field] = newVisibility;
          localStorage.setItem(
            "columnVisibility",
            JSON.stringify(visibilityState)
          );
        },
      });
    }

    return menu;
  };

  useEffect(() => {
    localStorage.removeItem("columnVisibility");
  }, []);

  const Classiccolumns = [
    // {
    //   title: "Parent Category",
    //   field: "CategoryParentName",
    //   headerMenu: headerMenu,
    //   headerFilter: "input",
    //   defaultVisible: true,
    //   frozen: true,
    // },
    {
      title: "Category",
      field: "CategoryName",
      headerMenu: headerMenu,
      headerFilter: "input",
      defaultVisible: true,
        formatter: function (cell) {
    // Apply underline styling
    return `<span style="text-decoration: underline; cursor: pointer;">${cell.getValue()}</span>`;
  },
      cellClick: function (e, cell) {
        const rowData = cell.getRow().getData();
        const CategoryId = rowData.CategoryId;
        const detailURL = `/purchase-by-category?startdate=${startdate}&enddate=${enddate}&selectedperiod=${selectReport}&brandid=${brandId}&categoryid=${CategoryId}&shownonzero=${
          checkbox.showNonZero == true ? 1 : 0
        }&showdeleteditems=${
          checkbox.showDeletedItems == true ? 1 : 0
        }&showparentItem=${
          checkbox.showParentItem == true ? 1 : 0
        }&selectedItems=${selectedItems}`;

        window.open(detailURL, "_blank");
      },
    },
    {
      title: "Quantity Purchased",
      field: "QuantityReceived",
      headerMenu: headerMenu,
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Bill SubTotal",
      field: "SubTotal",
      headerMenu: headerMenu,
      headerFilter: "input",
      bottomCalc: "sum",
      defaultVisible: true,
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Discount",
      field: "Discount",
      headerMenu: headerMenu,
      headerFilter: "input",
      bottomCalc: (values) => {
        const sum = values.reduce((a, b) => a + (parseFloat(b) || 0), 0);
        return sum.toFixed(2) + "%";
      },
      defaultVisible: true,
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Bill Total",
      field: "Total",
      headerMenu: headerMenu,
      headerFilter: "input",
      bottomCalc: "sum",
      defaultVisible: true,
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: `Current Stock As Of ${moment().format(
        dateFormate.toUpperCase()
      )}`,
      field: "CurrentStockQty",
      headerMenu: headerMenu,
      headerFilter: "input",
      bottomCalc: "sum",
      defaultVisible: true,
    },
    ...(checkUserPermission(PERMISSION_SHOW_COST_PRICE)
      ? [
          {
            title: `Current Stock Value As Of ${moment().format(
              dateFormate.toUpperCase()
            )}`,
            field: "StockValue",
            headerMenu: headerMenu,
            headerFilter: "input",
            bottomCalc: "sum",
            defaultVisible: true,
            topCalcFormatter: function (cell) {
              const totalValue = cell.getValue();
              if (
                totalValue == "0.00" ||
                totalValue === "" ||
                totalValue == null
              ) {
                return `${CurrencySymbol}0.0`;
              }

              return Reportcurrencysymbols(
                Number(totalValue),
                { CurrencySymbol },
                FractionDigits,
                currencySymbolLocation
              );
            },
            formatter: function (cell) {
              const value = cell.getValue();
              if (value == "0.00" || value === "") {
                return `${CurrencySymbol}0.0`;
              }
              return Reportcurrencysymbols(
                Number(value),
                { CurrencySymbol },
                FractionDigits,
                currencySymbolLocation
              );
            },
          },
        ]
      : []),
  ];

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const handleInputClick = (item) => {
    console.log(item, "checkitemdata");

    const newItem = {
      ItemId: item.ItemId,
      variationId: item.VariationId,
      itemName: item.VariationId > 0 ? item.VariationName : item.ItemName,
    };

    setSelectedItems((prev) => {
      // Optional: avoid duplicates by ItemId + variationId
      const exists = prev.some(
        (i) =>
          i.ItemId === newItem.ItemId && i.variationId === newItem.variationId
      );
      return exists ? prev : [...prev, newItem];
    });
    setSearchItemName("");
  };

  const handleDropdownchange = (selectedOptions) => {
    const items = selectedOptions?.map((opt) => opt.data) || [];
    setSelectedItems(items);
  };

  const onCheckBoxChange = (event, type) => {
    console.log(event, "checkevent");

    if (type == "NonZero") {
      setCheckBox({ ...checkbox, showNonZero: event.target.checked });
    } else if (type == "DeletedItems") {
      setCheckBox({ ...checkbox, showDeletedItems: event.target.checked });
    } else if (type == "ParentItem") {
      setCheckBox({ ...checkbox, showParentItem: event.target.checked });
    }
  };

  const selectOptions = selectedItems.map((item) => ({
    value: item.ItemId + "-" + item.variationId,
    label: item.itemName,
    data: item,
  }));

  const onRowClick = (rowData, event) => {
    console.log("Clicked row data:", rowData);
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Purchase By Categories Summary
                </li>
              </ul>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-4">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-3">Categories</label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    options={categories}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    isMulti={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    onChange={(selected) =>
                      setCategoriesId(selected?.map((e) => e.value) || [])
                    }
                    value={categories.filter((b) =>
                      categoriesId.includes(b.value)
                    )}
                    //onChange={(e) => setCategoriesId(e?.value)}
                    //value={categories.find((e) => e.value == categoriesId)}
                    className="custom-select-search z-5"
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between col-sm-6 gap-2">
              <div className="col-sm-6">
                <label className="col-form-label form-label">
                  Serach Items
                </label>
                <input
                  type="search"
                  placeholder="Search..."
                  // className="form-control-sm w-100 mt-1"
                  className="search-btn form-control form-control-sm w-100"
                  onChange={(e) => {
                    setSearchItemName(e.target.value);
                  }}
                  value={searchItemName}
                  style={{ width: "300px" }}
                />

                {suggestions?.length > 0 ? (
                  <>
                    <div className="dropdown">
                      <ul
                        className="dropdown-menu show dropdown-suggestion"
                        style={{
                          overflow: "auto",
                          width: "120% ",
                          maxWidth: "600px",
                        }}
                      >
                        {suggestions?.map((item) => (
                          <li
                            className="border-bottom"
                            key={item.ID}
                            onClick={(e) => handleInputClick(item)}
                          >
                            <Link
                              key={item.ID}
                              href="#"
                              class="dropdown-item"
                              data-name={item.Name?.toLowerCase()}
                            >
                              <img
                                src={item.ImageURL || Noimage}
                                onError={(e) => {
                                  e.currentTarget.src = Noimage;
                                }}
                                alt={item.Name}
                                className="img-thumbnail rounded-circle mr-4"
                                width="55"
                                height="55"
                                style={{
                                  height: "60px",
                                  objectFit: "contain",
                                }}
                              />
                              <div className="customer-info w-100">
                                <strong
                                  className="word-break-data"
                                  style={{
                                    fontWeight: "bold",
                                    color: "#333",
                                  }}
                                >
                                  {item.Name}{" "}
                                  {item.Name ? `(${item.Name})` : ""}
                                </strong>
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </>
                ) : null}
              </div>
              <div className="col-sm-6">
                <label className="col-form-label form-label">
                  Selected Items
                </label>
                <Select
                  onChange={(selectedOptions) =>
                    handleDropdownchange(selectedOptions)
                  }
                  options={selectOptions}
                  value={selectOptions} // use same list as value when all selected
                  isMulti
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  isClearable={true}
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  className="custom-search-select"
                />
              </div>
            </div>
            {showMoreFilters && (
              <>
                <div className="col-sm-2">
                  <label className="col-form-label form-label">
                    {/* Show Non Zero Items */}
                    Hide No Sale Items
                  </label>
                  <input
                    className="form-control form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    checked={checkbox.showNonZero}
                    id="showNonZero"
                    name="showNonZero"
                    onChange={(e) => onCheckBoxChange(e, "NonZero")}
                  />
                </div>
                <div className="col-sm-2">
                  <label className="col-form-label form-label">
                    Show Deleted Items
                  </label>
                  <input
                    className="form-control form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    checked={checkbox.showDeletedItems}
                    id="showDeletedItems"
                    name="showDeletedItems"
                    onChange={(e) => onCheckBoxChange(e, "DeletedItems")}
                  />
                </div>
                <div className="col-sm-2">
                  <label className="col-form-label form-label">
                    Hide Variation Items
                    {/* Show Parent Items */}
                  </label>
                  <input
                    className="form-control form-check-input"
                    style={{ width: "1.5em", height: "1.5em" }}
                    type="checkbox"
                    checked={checkbox.showParentItem}
                    id="showParentItem"
                    name="showParentItem"
                    onChange={(e) => onCheckBoxChange(e, "ParentItem")}
                  />
                </div>
                <div className="col-sm-3">
                  <label className="col-form-label col-md-3">Brands</label>
                  <div className="row">
                    <div className="col-md-12 z-3">
                      <Select
                        options={brands}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={true}
                        isMulti={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        onChange={(selected) =>
                          setBrandId(selected?.map((e) => e.value) || [])
                        }
                        value={brands.filter((b) => brandId.includes(b.value))}
                        className="custom-select-search"
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="col-auto" title="Advance Filter">
              <label className="col-form-label form-label"> </label>
              <Link
                className="form-control btn btn-sm btn-outline-dark mt-3"
                onClick={() => {
                  setShowMoreFilters(!showMoreFilters);
                }}
              >
                {showMoreFilters ? (
                  <i className="fa fa-arrow-up me-2 ms-2 mt-2"></i>
                ) : (
                  <i className="fa fa-arrow-down me-2 ms-2 mt-2"></i>
                )}
              </Link>
            </div>

            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apiCall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div className="card mt-3">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center " id="header">
                      <h6 class="p">SonarPos</h6>
                      <p className="fw-bold p-regular">
                        Purchase By Categories Summary
                      </p>
                      <div className="row mb-2">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format(
                                `${dateFormate.toUpperCase()}`
                              ) +
                              " - " +
                              moment(enddate).format(
                                `${dateFormate.toUpperCase()}`
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="table-responsive">
                    <div className="table mt-3"></div>

                    <div>
                      <CommonTabular
                        Data={responseData}
                        columns={Classiccolumns}
                        Groupvalue={[]}
                        Reportname={"Purchase By Categories Summary"}
                        frozenRowvalue={0}
                        dataTree={true}
                        dataTreeStartExpanded="_children"
                        Onrefresh={apiCall}
                      //   onRowClick={(rowData, e) => {
                      //  console.log(rowData, "selectedRowData")
                      //       const url = `/purchase-by-category?startdate=${startdate}&enddate=${enddate}&selectedperiod=${selectReport}&brandid=${brandId}&categoryid=${categoriesId}&shownonzero=${
                      //           checkbox.showNonZero == true ? 1 : 0
                      //         }&showdeleteditems=${
                      //           checkbox.showDeletedItems == true ? 1 : 0
                      //         }&showparentItem=${
                      //           checkbox.showParentItem == true ? 1 : 0
                      //         }&selectedItems=${selectedItems}`;
                      //       window.open(url, "_blank");
                      //   }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PurchasesByCategoriesSummary;
